/* template */
<template><component :is="(cpName)" :pageConfig="(pageConfig)" :info="(info)"/></template>

/* styles */
/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mc4517138"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexc4517138%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./index.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Findexc4517138%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mc4517138"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexc4517138/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'index-common':getComponent(require("./index-common.mpx?isComponent&outputPath=components%2Findex-commoncedc923c%2Findex")),'index-sign':getComponent(require("./index-sign.mpx?isComponent&outputPath=components%2Findex-signd5ca0498%2Findex")),'launch-app':getComponent(require("./index-app.mpx?isComponent&outputPath=components%2Findex-app35525490%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
